<!--
 * @Author: FengXiao
 * @Date: 2020-07-15 16:18:12
 * @LastEditors: FengXiao
 * @LastEditTime: 2021-01-22 22:51:15
-->
<template>
  <div class="user-cennter-page page-container">
    <div class="content">
      <div class="user_info-menu-wrap">
        <div class="user_info-menu">
          <div class="user_info-bl">
            <div class="user_avatar"><img :src="user.avatar" alt="" /></div>
            <div class="user_name">
              {{ user.nickname }}
              <!-- <span class="edit_btn" @click.stop="editUserInfo('name')">点击修改</span> -->
            </div>
            <div class="user_phone" v-if="user.mobile">
              +{{ user.nation_code }} {{ user.mobile }}
              <!-- <span class="edit_btn" @click.stop="editUserInfo('mobile')">点击修改</span> -->
            </div>
            <!-- <div class="user_phone" v-else>
              <span class="bind_btn" @click.stop="firstBindMobile">绑定手机</span>
            </div> -->
            <div class="vip_period" v-if="vipInfo.status === 1">会员有效期至：{{ vipInfo.end_time }}</div>
          </div>
          <div class="menus-wrap">
            <div
              class="menu"
              :class="{ activated: activeMenu === menu.value }"
              v-for="menu in menuList"
              :key="menu.value"
              @click="onClickMenu(menu.value)"
            >
              {{ menu.label }}
            </div>
          </div>
        </div>
      </div>
      <div class="left-bl">
        <router-view />
      </div>
    </div>
    <el-dialog class="edit-dialog" :visible.sync="editNickNameDialog" width="400px" :show-close="false">
      <div class="edit-title">修改昵称</div>
      <div class="input-wrap">
        <input type="text" placeholder="请输入新昵称" v-model="newNickname" maxlength="20" />
        <span class="ipt_btn" :class="{ disabled: !newNickname.length }" @click="editNicknameConfirm">
          确定修改
        </span>
      </div>
    </el-dialog>
    <el-dialog class="edit-dialog" :visible.sync="editMobileDialog" width="400px" :show-close="false">
      <div class="edit-title-wrap">
        <div class="edit-title">{{ editStep === 1 && !isBindNewMobile ? '验证原手机号码' : '绑定新手机号码' }}</div>
        <div class="step-number" v-show="!isBindNewMobile">{{ editStep }} / 2</div>
      </div>
      <div class="inputs-bl">
        <div class="input-wrap" :class="{ disabled: editStep === 1 && !isBindNewMobile }">
          <span class="nation_code" @click.stop="showSelNationCodeDialog">
            +{{ editMobileForm.nation_code }}
            <i class="iconfont iconarrow-down" v-if="editStep === 2 || isBindNewMobile"></i>
          </span>
          <input
            type="text"
            placeholder="请输入手机号码"
            v-model="editMobileForm.mobile"
            @keyup="onEditInput($event, 'mobile')"
            @afterpaste="onEditInput($event, 'mobile')"
            maxlength="11"
            :disabled="editStep === 1 && !isBindNewMobile"
          />
          <span class="ipt_btn" :class="{ disabled: disabledBtn }" @click="sendCaptcha">
            {{ captchaSeconds > 0 ? `${captchaSeconds}秒` : '获取验证码' }}
          </span>
        </div>
        <div class="input-wrap">
          <input type="text" placeholder="请输入验证码" v-model="editMobileForm.captcha" @input="onEditInput($event, 'captcha')" />
          <span class="ipt_btn" :class="{ disabled: !(editErrorMsg === '' && checkCaptcha()) }" @click="editMobileConfirm" v-show="editMobileBtnText">
            {{ editErrorMsg || editMobileBtnText }}
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog :show-close="false" class="select-nation-code-dialog" :visible.sync="selNationCodeDialog" width="400px">
      <div class="dialog-title">国家选择</div>
      <div class="dialog-container">
        <div v-for="(codes, i) in nationCodes" class="nation_codes-wrap" :key="`codes_${i}`">
          <div class="content_title">{{ codes.diff }}</div>
          <div v-for="(code, j) in codes.countrys" class="nation_code" @click="selectNationCode(code.code)" :key="`code_${j}`">
            <span>{{ code.name }}</span>
            <span>{{ '+' + code.code }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import requestApi from '@/service';
import Cookies from 'js-cookie';
import configFields from '@/utils/configFields';
const { DEFAULT_NATION_CODE } = configFields;
import { Dialog } from 'element-ui';
import { mapState } from 'vuex';

export default {
  name: 'UserCenter',
  components: {
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      user: {},
      activeMenu: 'order',
      menuList: [
		{ label: '一席会员', value: 'vip_detail' },
        { label: '我的订单', value: 'order' },
        { label: '兑换', value: 'invitationAndExchange' },
        { label: '我的收藏', value: 'collection' },
        { label: '退出登录', value: 'logout' },
      ],
      editNickNameDialog: false, // 修改昵称
      editMobileDialog: false, // 修改手机号
      newNickname: '',
      editMobileForm: {
        mobile: '',
        captcha: '',
      },
      editStep: 1,
      captchaSeconds: 0, // 验证码倒计时
      editErrorMsg: '',
      selNationCodeDialog: false,
      nationCodes: [], // 国家区号
      isBindNewMobile: false, // 首次绑定手机号
    };
  },
  beforeRouteEnter(to, from, next) {
    if (!Cookies.get('token')) {
      window.$router.push('/login');
    } else {
      next(vm => {
        if (to.params.bindMobile) {
          vm.firstBindMobile();
        }
      });
    }
  },
  activated() {
    Object.assign(this.$data, this.$options.data());
    this.init();
  },
  watch: {
    $route(to) {
      this.selectMenu(to.path);
    },
  },
  computed: {
    ...mapState(['vipInfo']),
    disabledBtn() {
      return this.captchaSeconds > 0 || !this.checkPhone();
    },
    editMobileBtnText() {
      return this.isBindNewMobile ? '绑 定' : this.editStep === 1 ? '' : '确认修改';
    },
  },
  methods: {
    init() {
      this.initUserInfo();
      this.selectMenu(this.$route.path);
      this.initScrollTop();
    },
    selectMenu(path) {
      for (const menu of this.menuList) {
        if (path.includes(`/${menu.value}`)) {
          this.activeMenu = menu.value;
          break;
        }
      }
    },
    initUserInfo() {
      this.user = this.$store.state.user || {};
      this.user.nation_code = this.user.nation_code || DEFAULT_NATION_CODE;
    },
    /**
     * @description: 退出登录
     * 清除当前登录用户信息 以及cookie中的token
     */
    logout() {
      this.$confirm('确定退出登录？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
      })
        .then(() => {
          this.$store.commit('setUser', null);
          this.$store.commit('setToken', '');
          // this.$store.dispatch('getVipInfo');
          this.gotoLogin();
        })
        .catch(() => {});
    },
    onClickMenu(value) {
      if (value === 'logout') {
        this.logout();
      } else {
        const path = `/userCenter/${value}`;
        if (this.$route.path !== path) {
          this.$router.push(path);
        }
      }
    },
    editUserInfo(type) {
      switch (type) {
        case 'name':
          this.editNickNameDialog = true;
          break;
        case 'mobile':
          this.showEditMobile();
          break;
        default:
          break;
      }
    },
    showEditMobile() {
      this.editStep = 1;
      this.editMobileForm = {
        mobile: this.user.mobile,
        captcha: '',
        nation_code: this.user.nation_code || 86,
      };
      this.editErrorMsg = '';
      this.editMobileDialog = true;
    },
    /**
     * @description: 确认修改新昵称
     */
    editNicknameConfirm() {
      if (this.newNickname) {
        requestApi(
          '/v3/api/v1/change/profile/',
          {
            nickname: this.newNickname,
          },
          'PUT'
        ).then(res => {
          if (res && res.user && res.token) {
            this.$store.commit('setUser', res.user);
            this.$store.commit('setToken', res.token);
            this.initUserInfo();
          }
        });
      }
    },
    checkMobileByLogin() {
      requestApi(
        '/v3/api/v1/login/',
        {
          user_name: this.editMobileForm.mobile,
          v_code: this.editMobileForm.captcha,
          nation_code: this.editMobileForm.nation_code,
        },
        'POST',
        {},
        {
          printMsg: false,
        }
      ).then(
        ({ user, token }) => {
          this.editMobileForm = {
            nation_code: this.user.nation_code,
            mobile: '',
            captcha: '',
          };
          this.editErrorMsg = '';
          this.editStep = 2;
          this.$store.commit('setUser', user);
          this.$store.commit('setToken', token);
		  this.$store.dispatch('getVipInfo');
          this.initUserInfo();
          clearTimeout(this.captchaTimer);
          this.captchaSeconds = 0;
          if (this.isBindNewMobile) this.isBindNewMobile = false;
        },
        err => {
          this.editErrorMsg = err.error_msg;
        }
      );
    },
    bindNewMobile() {
      const params = this.editMobileForm;
      params.v_code = params.captcha;
      delete params.captcha;
      requestApi(
        '/v3/api/v1/bind/mobile/',
        params,
        'POST',
        {},
        {
          printMsg: false,
        }
      ).then(
        res => {
          this.editMobileDialog = false;
          this.editErrorMsg = '';
          this.$store.commit('setUser', res.user);
          this.$store.commit('setToken', res.token);
		  this.$store.dispatch('getVipInfo');
          this.initUserInfo();
        },
        err => {
          this.editErrorMsg = err.error_msg;
        }
      );
    },
    editMobileConfirm() {
      if (!this.checkCaptcha() || this.editErrorMsg) return;
      this.bindNewMobile();
    },
    checkPhone() {
      return (
        this.editMobileForm.mobile && this.editMobileForm.mobile.length === 11 && /^1(3|4|5|6|7|8|9)[0-9]\d{8}$/.test(this.editMobileForm.mobile)
      );
    },
    checkCaptcha() {
      return this.editMobileForm.captcha && this.editMobileForm.captcha.length === 4;
    },
    sendCaptcha() {
      if (!this.disabledBtn) {
        this.captchaSeconds = 60;
        this.startCaptchaTimer();
        // requestApi(
        //   '/v3/api/v1/send/vcode/',
        //   {
        //     mobile: this.editMobileForm.mobile,
        //     nation_code: this.editMobileForm.nation_code,
        //   },
        //   'POST'
        // );
		var md5 = this.$md5(this.ts + '64!0j1ydr(5+0^o7')
		requestApi(
		  '/v3/api/v1/send/vcode/',
		  {
		    mobile: this.editMobileForm.mobile,
		    nation_code: this.editMobileForm.nation_code,
		  },
		  'POST',
		  {
			  ts:this.ts,
			  signature: md5,
		  },
		);
      }
    },
    /**
     * @description: 开启定时器
     */
    startCaptchaTimer() {
      if (this.captchaTimer) {
        clearTimeout(this.captchaTimer);
      }
      this.captchaTimer = setTimeout(() => {
        this.captchaTimer = null;
        this.captchaSeconds -= 1;
        if (this.captchaSeconds < 10) {
          this.captchaSeconds = `0${this.captchaSeconds}`;
        }
        if (this.captchaSeconds > 0) {
          this.startCaptchaTimer();
        }
      }, 1000);
    },
    onEditInput(e, key) {
      if (key === 'mobile') {
        this.editMobileForm[key] = e.target.value.replace(/[^\d]/g, '');
      } else {
        this.editMobileForm[key] = e.target.value;
      }
      if (this.editErrorMsg) this.editErrorMsg = '';
      if (this.checkPhone() && this.checkCaptcha() && this.editStep === 1 && !this.isBindNewMobile) {
        this.checkMobileByLogin();
      }
    },
    showSelNationCodeDialog() {
      this.getNationCodes();
      this.selNationCodeDialog = true;
    },
    getNationCodes() {
      if (!(this.nationCodes && this.nationCodes.length)) {
        requestApi('/v3/api/h5/nations/').then(res => {
          this.nationCodes = res.items;
        });
      }
    },
    selectNationCode(code) {
      this.editMobileForm.nation_code = code;
      this.selNationCodeDialog = false;
    },
    /**
     * @description: 首次账号绑定手机
     */
    firstBindMobile() {
      this.isBindNewMobile = true;
      this.showEditMobile();
    },
  },
};
</script>

<style lang="scss" scoped>
.user-cennter-page {
  padding-top: 30px;
  background: $C15;
}
.content {
  margin-top: 20px;
  max-width: 1070px;
  display: flex;
  align-items: stretch;
  .user_info-menu {
    width: 250px;
    // max-height: 368px;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    .user_info-bl {
      text-align: center;
      padding-top: 40px;
      padding-bottom: 20px;
      background-color: $C1;
      margin-bottom: 1px;
      .user_avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        margin: 0 auto 15px;
      }
      .user_name {
        margin-bottom: 5px;
        font-weight: bold;
        color: $C3;
        font-size: 18px;
        line-height: 20px;
        cursor: pointer;
      }
      .user_phone,
      .vip_period {
        color: #4a4a4a;
        font-size: 12px;
        line-height: 17px;
      }
      .user_phone {
        cursor: pointer;
        margin-bottom: 6px;
      }
      .user_name,
      .user_phone {
        position: relative;
        .edit_btn {
          font-size: 12px;
          color: $C13;
          font-weight: 400;
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translate(0, -50%);
          visibility: hidden;
        }
        &:hover {
          .edit_btn {
            visibility: visible;
          }
        }
      }
    }
    .menus-wrap {
      .menu {
        position: relative;
        font-size: 14px;
        text-align: center;
        height: 50px;
        line-height: 50px;
        color: $C6;
        background-color: $C1;
        margin-bottom: 1px;
        cursor: pointer;
        &:hover {
          background: $C2;
          color: $C1;
          transition: all 0.3s ease;
          font-weight: bold;
        }
        &.activated {
          font-weight: bold;
          color: $C7;
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 100%;
            width: 4px;
            background: $C2;
          }
          &:hover {
            color: $C1;
          }
        }
      }
    }
  }
  .left-bl {
    flex: 1;
    margin-left: 10px;
	max-width: 800px;
  }
}
.edit-dialog {
  ::v-deep.el-dialog {
    height: 200px;
  }
  ::v-deep.el-dialog__body {
    padding: 0 30px 0;
  }
  .edit-title {
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 15px;
    color: $C3;
    font-family: HYXinRenWenSongW;
  }
  .input-wrap {
    color: $C3;
    height: 40px;
    border: 1px solid $A6;
    width: 100%;
    display: flex;
    align-items: center;
    background: $C1;
    margin-bottom: 20px;
    input {
      font-size: 12px;
      border: none;
      outline: none;
      height: 100%;
      flex: 1;
      padding: 0 0 0 10px;
    }
    &.disabled {
      color: $C13;
      input {
        color: $C13;
        &:disabled {
          background: $C1;
        }
      }
    }
  }
  .ipt_btn {
    width: 80px;
    height: 36px;
    background: $C2;
    color: $C1;
    font-size: 12px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease-in;
    margin-right: 2px;
    &.disabled {
      background: $C10;
      color: $C13;
      cursor: default;
    }
  }
  .edit-title-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 15px;
    .edit-title {
      margin-bottom: 0;
    }
    .step-number {
      font-size: 12px;
      line-height: 16px;
      color: $C3;
    }
  }
  .nation_code {
    font-size: 12px;
    height: 40px;
    line-height: 40px;
    margin-left: 15px;
    position: relative;
    cursor: pointer;
    .iconarrow-down {
      position: absolute;
      top: calc(50% + 12px);
      left: calc(50% - 2px);
      font-size: 10px;
      transform: translate(-50%, -50%) scale(0.6);
    }
  }
}
.select-nation-code-dialog {
  ::v-deep.el-dialog__header {
    padding: 0;
  }
  ::v-deep.el-dialog__body {
    padding: 0;
  }
  .dialog-title {
    background: $C1;
    font-size: 18px;
    padding: 20px 0 10px;
    font-family: HYXinRenWenSongW;
    text-align: center;
    color: $C3;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  }
  .dialog-container {
    height: 50vh;
    overflow-y: auto;
  }
  .content_title {
    font-size: 14px;
    background: #ecedee;
    color: $C3;
    padding: 8px 10px;
  }
  .nation_code {
    padding: 5px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      background: $C8;
      color: $C3;
    }
  }
}
</style>
